import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {Icon, Input, Loader, Popup, Table} from 'semantic-ui-react';
import {validateUnique} from '../../../utils';
import {Actions} from '../../../../common/actions';
import {enterKeyCode, tabKeyCode} from '../../../../common/constants/keyCodes';
import OnOrdersModal from '../../../../part/components/analysis/edit/modals/onOrders';
import DeleteIcon from '../../common/icons/DeleteIcon';
import PartsOrdersIcon from '../../common/icons/PartsOrdersIcon';

const {
  getCampaignPart,
  addMessageBoxError,
  changePartsMinStock,
  addElementToParts,
} = Actions;

const FormParts = ({
  dataRow,
  handleChange,
  handleAddItem,
  handleKeyDown,
  loadingPart,
}) => {
  const {
    partno,
    partName,
    availableStock,
    dealersStock,
    minStock,
    onOrder,
    onOrderConfirmed,
  } = dataRow;
  const validateBtn = partName === '';

  return (
    <Table.Row textAlign='center'>
      <Table.Cell>
        <Input
          className='twc-part-input code-input'
          placeholder='No. de parte'
          value={partno}
          type='text'
          name='partno'
          loading={loadingPart}
          disabled={loadingPart}
          onKeyDown={handleKeyDown}
          onChange={handleChange}
        />
      </Table.Cell>
      <Table.Cell>{partName}</Table.Cell>
      <Table.Cell>
        <span>{onOrder}</span>
        <span className='margin-left'>{onOrderConfirmed}</span>
      </Table.Cell>
      <Table.Cell>{dealersStock}</Table.Cell>
      <Table.Cell>{availableStock}</Table.Cell>
      <Table.Cell>
        <Input
          value={minStock}
          type='number'
          min='0'
          name='minStock'
          disabled={loadingPart}
          onChange={handleChange}
          onWheel={(e) => e.target.blur()}
        />
      </Table.Cell>
      <Table.Cell>
        <Popup
          trigger={
            <Icon
              disabled={validateBtn}
              onClick={handleAddItem}
              color='green'
              size='large'
              bordered
              inverted
              name='add'
            />
          }
          content='Añadir parte'
          position='top center'
          inverted
        />
      </Table.Cell>
    </Table.Row>
  );
};

const DisplayData = ({
  item,
  idx,
  isUserTde,
  campaign,
  campaingNo,
  handleUpdateAmount,
}) => {
  const {
    partno,
    partName,
    onOrder,
    minStock,
    flagMinStock,
    dealersStock,
    availableStock,
    onOrderConfirmed,
  } = item;

  return (
    <Table.Row key={idx} textAlign='center'>
      <Table.Cell>{partno}</Table.Cell>
      <Table.Cell>{partName}</Table.Cell>
      <Table.Cell>
        <OnOrdersModal
          code={partno}
          quantity={onOrder || 0}
          quantityConfirmed={onOrderConfirmed || 0}
        />
      </Table.Cell>
      <Table.Cell>{dealersStock}</Table.Cell>
      <Table.Cell>{availableStock}</Table.Cell>
      {isUserTde && (
        <>
          <Table.Cell>
            <Input
              value={minStock}
              type='number'
              min='0'
              name='minStock'
              error={flagMinStock > 0}
              onChange={(e, {value}) => handleUpdateAmount(value, idx)}
              onWheel={(e) => e.target.blur()}
            />
            {flagMinStock > 0 && (
              <p className='error message'>
                Stock minimo supera stock disponible
              </p>
            )}
          </Table.Cell>
          <Table.Cell>
            <DeleteIcon index={idx} data={item} dataType='partsArray' />
            <PartsOrdersIcon
              campaingNo={campaingNo}
              isUserTde={isUserTde}
              part={partno}
              inactiveCampaign={campaign.status !== 'A'}
            />
          </Table.Cell>
        </>
      )}
    </Table.Row>
  );
};

const initialState = {
  'partno': '',
  'partName': '',
  'availableStock': 0,
  'dealersStock': 0,
  'minStock': 0,
};

const PartsTable = ({
  dataTable,
  isUserTde,
  disabledBtns,
  part,
  campaign,
  campaingNo,
  loadingPart,
  loadingPartsArray,
}) => {
  const [dataRow, setDataRow] = useState(initialState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(part).length) {
      setDataRow({...dataRow, ...part});
    } else {
      setDataRow({...initialState});
    }
  }, [part]);

  const handleUpdateAmount = (value, idx) => {
    const minStock = isNaN(value) ? 0 : Number(value);
    dispatch(changePartsMinStock(idx, minStock));
  };

  const handleAddItem = () => {
    const {partno, minStock} = dataRow;
    const newParts = [...dataTable];
    const item = {campaingNo, partno, 'minStock': +minStock};

    if (validateUnique(newParts, 'partno', partno)) {
      setDataRow({...initialState});
      dispatch(addElementToParts(item));
    } else {
      dispatch(
        addMessageBoxError(`El item ${partno} ya se encuentra en la lista`)
      );
    }
  };

  const handleKeyDown = (e) => {
    const {partno} = dataRow;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (partno.length > 1) {
        dispatch(getCampaignPart(partno));
      }
      e.preventDefault();
    }
  };

  const handleChange = (e, {value, name}) => {
    setDataRow({...dataRow, [name]: value.toUpperCase()});
  };

  const renderTableRecords = () => {
    if (!dataTable.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay partes disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
    return dataTable.map((part, idx) => (
      <DisplayData
        disabledBtns={disabledBtns}
        isUserTde={isUserTde}
        campaign={campaign}
        campaingNo={campaingNo}
        handleUpdateAmount={handleUpdateAmount}
        key={idx}
        item={part}
        idx={idx}
      />
    ));
  };

  if (loadingPartsArray) {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Cargando Partes' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  return (
    <div className='campaign-container-table'>
      <Table striped>
        <Table.Header>
          <Table.Row textAlign='center'>
            <Table.HeaderCell>NÚMERO PARTE</Table.HeaderCell>
            <Table.HeaderCell>DESCRIPCIÓN</Table.HeaderCell>
            <Table.HeaderCell>ON / ORDER</Table.HeaderCell>
            <Table.HeaderCell>STOCK DEALER</Table.HeaderCell>
            <Table.HeaderCell>STOCK TDE</Table.HeaderCell>
            {isUserTde && (
              <>
                <Table.HeaderCell>STOCK MÍNIMO</Table.HeaderCell>
                <Table.HeaderCell>ACCIONES</Table.HeaderCell>
              </>
            )}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {!disabledBtns && isUserTde && (
            <FormParts
              handleChange={handleChange}
              dataRow={dataRow}
              handleAddItem={handleAddItem}
              handleKeyDown={handleKeyDown}
              loadingPart={loadingPart}
            />
          )}
          {renderTableRecords()}
        </Table.Body>
      </Table>
    </div>
  );
};

export default PartsTable;
